var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.conversacion
      ? _c(
          "button",
          { staticClass: "btn btn-primary m-md", on: { click: _vm.show } },
          [_vm._v("Ver Conversacion")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        { staticClass: "modal fade", attrs: { role: "dialog", id: "Modal" } },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "ibox",
                        staticStyle: { overflow: "scroll" },
                      },
                      _vm._l(_vm.conversacion.detalles, function (item, index) {
                        return _c("div", { key: index }, [
                          _c(
                            "div",
                            { class: "conver " + _vm.revisa_direccion(item) },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.muestra_mensaje(item)) +
                                  "\r\n                                            "
                              ),
                              _c(
                                "div",
                                { staticStyle: { "font-size": "11px" } },
                                [
                                  _vm._v(
                                    "\r\n                                                " +
                                      _vm._s(item.created_at) +
                                      "\r\n                                            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [_vm._v("Conversacion ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }